// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__yS","cls2":"CreateSocialItem-cls2_M7O CreateSocialItem-cls1__yS","spaced":"CreateSocialItem-spaced_Knl"};